// extracted by mini-css-extract-plugin
export default {"sidebarRow":"Sidebar_sidebarRow__JZQn9","loginButton":"Sidebar_loginButton__OhCp4","switchTypeButton":"Sidebar_switchTypeButton__WMVN+","languageBox":"Sidebar_languageBox__kouDD"};